import { Box, Grid, Typography, useTheme } from '@mui/material';

import { DEFAULT_BORDER } from 'src/constants';

import { TextDisplay } from '../../AddMerchantPage/steps/SummaryInformation/components/InformationSection/components/TextDisplay';

interface PartnerBillingDetailsProps {
    partnerEmailAddress: string;
    partnerTelephone: string;
    partnerName: string;
}

export const PartnerBillingDetails: React.FC<PartnerBillingDetailsProps> = ({
    partnerEmailAddress,
    partnerTelephone,
    partnerName,
}) => {
    const theme = useTheme();
    return (
        <Grid
            item
            xs={12}
            sx={{
                ...DEFAULT_BORDER,
                backgroundColor: theme.palette.common.white,
                boxShadow: '0px 4px 20px rgba(38, 50, 56, 0.1)',
                padding: '32px 24px',
            }}
            spacing={2}
        >
            <Grid item xs={12}>
                <Box display="flex" flexDirection="column" gap="8px" marginBottom="8px">
                    <Typography variant="h2">Partner Billing Details</Typography>
                </Box>
            </Grid>

            <Grid container item xs={12} spacing={2}>
                <Grid item xs={12} sm={4}>
                    <TextDisplay
                        label="Name"
                        value={partnerName}
                        labelTypographyStyles={{
                            marginBottom: '4px',
                        }}
                        valueTypographyStyles={{
                            fontSize: '14px',
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <TextDisplay
                        label="Telephone Number"
                        value={partnerTelephone}
                        labelTypographyStyles={{
                            marginBottom: '4px',
                        }}
                        valueTypographyStyles={{
                            fontSize: '14px',
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <TextDisplay
                        label="Email Address"
                        value={partnerEmailAddress}
                        labelTypographyStyles={{
                            marginBottom: '4px',
                        }}
                        valueTypographyStyles={{
                            fontSize: '14px',
                        }}
                    />
                </Grid>
            </Grid>
        </Grid>
    );
};
